/* istanbul ignore file */
import generalInterface from './interface';
import clientGoalInterface from './client-goal-interface';
import userInterface from './user-interface';

function createApi(apis) {
  return global.API ? global.API.wrap(apis, 'xhrMutualFund') : null;
}

const generalApi = createApi(generalInterface);
const clientGoal = createApi(clientGoalInterface);
const user = createApi(userInterface);

export default {
  ...generalApi,
  clientGoal,
  user,
};
